import { Image as ToolkitImage } from '@storyofams/storyblok-toolkit';
import { defineMessages, useIntl } from 'react-intl';
import { classNames, getLinkProps } from '~/lib';
import { Link } from '.';
import { social } from './Layout';

interface AuthorCardProps {
  content: any;
  className?: string;
}

const messages = defineMessages({
  title: {
    id: 'author.title',
    defaultMessage: 'Author / Writer',
  },
});

export const AuthorCard = ({ content, className }: AuthorCardProps) => {
  const { formatMessage } = useIntl();

  return (
    <div
      className={classNames(
        'flex flex-col items-center justify-center lg:max-w-7xl mx-auto',
        className,
      )}
    >
      <div className="uppercase text-grey-500 font-sm mb-6">
        {formatMessage(messages.title)}
      </div>
      <div className="w-24 h-24 rounded-full overflow-hidden mb-5">
        <ToolkitImage
          alt={content?.photo?.alt || ''}
          src={content?.photo?.filename}
          fluid={content?.size ? 100 : 100}
          fit="contain"
          showPlaceholder={false}
          className={classNames('w-full max-w-100 rounded-full')}
        />
      </div>
      <div className="text-2xl font-display font-bold">{content?.name}</div>
      <div className="text-grey-700 text-lg">{content?.position}</div>
      <div className="flex mt-4">
        {social.map((item) => {
          if (!content?.[item.key]) {
            return null;
          }

          return (
            <Link
              key={item.key}
              href={getLinkProps(content?.[item.key])}
              className="text-gray-900 hover:text-gray-700 ml-3 first:ml-0"
            >
              <span className="sr-only">{item.name}</span>
              <item.icon className="h-6 w-6" aria-hidden="true" />
            </Link>
          );
        })}
      </div>
    </div>
  );
};
